import { IUtmkCoordinateInfo } from "./utmkCoordinateInfo.types";

export class UtmkCoordinateInfo implements IUtmkCoordinateInfo {
  utmkX: string;
  utmkY: string;

  constructor(data: IUtmkCoordinateInfo) {
    this.utmkX = data.utmkX;
    this.utmkY = data.utmkY;
  }
}
